/**
 * ForaVida Inmeettool – Glazen Schuifwand v1.1.0
 *
 * Client-side calculation engine for glass sliding door measurements.
 * Shared helpers loaded from FviHelpers (foravida-fvi-helpers.js).
 *
 * @package ForaVida_Inmeettool
 */
( function () {
	'use strict';

	var H = window.FviHelpers;

	// ===== i18n =====
	var i18n = ( typeof fviSchuifwandData !== 'undefined' && fviSchuifwandData.i18n ) ? fviSchuifwandData.i18n : {};
	var t = function ( key, fallback ) { return i18n[ key ] || fallback || key; };

	var W = new WeakMap();
	var PLACEHOLDER = '<p class="fvi-placeholder">' + t( 'placeholder' ) + '</p>';

	function state( root ) {
		if ( ! W.has( root ) ) { W.set( root, { lastResult: null } ); }
		return W.get( root );
	}

	// Width and height bands come from wp_localize_script (see
	// fv_inmeettool_schuifwand_width_bands / _height_bands in inc/inmeettool.php).
	// Keeping the data server-side ensures labels like "Tot 820 mm (1-rail)"
	// pick up the active locale — no hardcoded Dutch in this bundle.
	var widthBands  = ( typeof fviSchuifwandData !== 'undefined' && fviSchuifwandData.widthBands )  ? fviSchuifwandData.widthBands  : [];
	var heightBands = ( typeof fviSchuifwandData !== 'undefined' && fviSchuifwandData.heightBands ) ? fviSchuifwandData.heightBands : [];

	var COLORS = [
		{ slug: 'matzwart',  label: t( 'colorMatzwart' ),  swatch: 'fvi-swatch--black' },
		{ slug: 'antraciet', label: t( 'colorAntraciet' ), swatch: 'fvi-swatch--anthracite' },
		{ slug: 'mat-wit',   label: t( 'colorMatWit' ),    swatch: 'fvi-swatch--white' }
	];

	// Follow <html lang> — same pattern as _fvi-helpers.js fmt().
	var pageLocale = ( document.documentElement.lang || 'nl-NL' );
	var fmt = function ( n ) {
		return n ? n.toLocaleString( pageLocale ) : '\u2014';
	};

	function pickWidthBand( w ) {
		if ( ! w ) { return null; }
		for ( var i = 0; i < widthBands.length; i++ ) {
			if ( w <= widthBands[ i ].max ) { return widthBands[ i ]; }
		}
		return null;
	}

	function pickHeightBand( h ) {
		if ( ! h ) { return null; }
		for ( var i = 0; i < heightBands.length; i++ ) {
			if ( h >= heightBands[ i ].min && h <= heightBands[ i ].max ) { return heightBands[ i ]; }
		}
		return null;
	}

	function slugifyHeight( label ) {
		if ( ! label ) { return ''; }
		return label.toLowerCase()
			.replace( /\s*\u2013\s*/g, '-' )
			.replace( /\s+/g, '-' )
			.replace( /[^a-z0-9-]/g, '' );
	}

	function buildProductLink( rails, maxWidth, heightLabel, colorSlug ) {
		if ( ! rails || ! maxWidth || ! heightLabel || ! colorSlug ) { return ''; }
		var heightParam = slugifyHeight( heightLabel );
		var productSlug = rails + '-rail-glazen-schuifwand-tot-' + maxWidth + '-mm-' + colorSlug;
		return 'https://www.foravida.nl/product/' + productSlug + '/?attribute_pa_inbouwhoogte=' + heightParam;
	}

	function resultRow( label, value, modifier ) {
		return '<div class="fvi-result-row fvi-result-row--' + modifier + '">' +
			'<span class="fvi-result-label">' + label + '</span>' +
			'<span class="fvi-result-value">' + value + '</span>' +
			'</div>';
	}

	// ===== Main calculation =====
	function calculate( root ) {
		var wInput   = root.querySelector( '[data-fvi="wBottom"]' );
		var hInput   = root.querySelector( '[data-fvi="hLeft"]' );
		var resultEl = root.querySelector( '[data-fvi="result"]' );

		var wMax = Number( wInput.value ) || 0;
		var hMax = Number( hInput.value ) || 0;

		if ( ! wMax || ! hMax ) {
			H.showError( root, t( 'fillBoth' ) );
			return;
		}
		if ( wMax < 820 || wMax > 7150 ) {
			H.showError( root, t( 'widthRange' ) );
			return;
		}

		var wBand = pickWidthBand( wMax );
		var hBand = pickHeightBand( hMax );

		var heightNote  = '';
		var heightError = '';

		if ( hMax && ( hMax < 1990 || hMax > 2720 ) ) {
			heightError = '<div class="fvi-warn">' + t( 'heightOutOfRange' ) + '</div>';
		} else if ( hMax && ! hBand ) {
			var hAdjusted     = hMax - 20;
			var hBandAdjusted = pickHeightBand( hAdjusted );
			if ( hBandAdjusted ) {
				hBand = hBandAdjusted;
				heightNote = '<div class="fvi-ok">' + t( 'adviceLowerHeight' ).replace( '%s', '<span class="fvi-badge">' + hBand.label + '</span>' ) + '</div>';
			} else {
				heightError = '<div class="fvi-warn">' + t( 'heightNoFit' ) + '</div>';
			}
		}

		if ( ! wBand ) {
			resultEl.innerHTML =
				'<div class="fvi-warn">' + t( 'widthOutOfRange' ).replace( '%1$s', fmt( wMax ) ).replace( '%2$s', '7.150' ) + '</div>';
			return;
		}

		var diff     = wBand.max - wMax;
		var overlaps = Math.max( 0, ( wBand.rails || 0 ) - 1 );
		var perDoor  = 10;
		if ( overlaps > 0 ) {
			perDoor = Math.round( ( diff / overlaps ) + 10 );
		}

		var uMm = ' ' + t( 'unitMm' );

		var header =
			'<div class="fvi-card__header">' +
			'<span class="fvi-card__title">' + t( 'resultTitle' ) + '</span>' +
			'<div class="fvi-card__actions">' +
			'<button class="fvi-btn fvi-btn--icon" data-fvi-action="print" title="' + t( 'printTitle' ) + '">' + H.ICON_PRINT + '</button>' +
			'<button class="fvi-btn fvi-btn--icon" data-fvi-action="copy" title="' + t( 'copyTitle' ) + '">' + H.ICON_COPY + '</button>' +
			'</div></div>';

		var rows =
			'<div class="fvi-results-grid">' +
			resultRow( t( 'rowMeasuredWidth' ), fmt( wMax ) + uMm, 'primary' ) +
			resultRow( t( 'rowMeasuredHeight' ), fmt( hMax ) + uMm, 'sage' ) +
			resultRow( t( 'rowInstallWidth' ), wBand.label, 'muted' ) +
			resultRow( t( 'rowOverlapPerDoor' ), perDoor + uMm, 'primary' );

		if ( heightError ) {
			rows += '</div>' + heightError;
		} else if ( hBand ) {
			rows += resultRow( t( 'rowInstallHeight' ), hBand.label, 'accent' );
			rows += '</div>';
			if ( heightNote ) { rows += heightNote; }
		} else {
			rows += '</div>';
		}

		var colorHtml = '';
		if ( ! heightError && wBand && hBand ) {
			var links = '';
			for ( var i = 0; i < COLORS.length; i++ ) {
				var c    = COLORS[ i ];
				var href = buildProductLink( wBand.rails, wBand.max, hBand.label, c.slug );
				links +=
					'<a class="fvi-chip" target="_blank" rel="noopener" href="' + href + '">' +
					'<span class="fvi-swatch ' + c.swatch + '"></span>' + c.label + '</a>';
			}
			colorHtml =
				'<div class="fvi-color-section">' +
				'<span class="fvi-overline">' + t( 'colorPickHeading' ) + '</span>' +
				'<div class="fvi-choice">' + links + '</div>' +
				'<p class="fvi-footer">' + t( 'colorPickFooter' ) + '</p>' +
				'</div>';
		}

		resultEl.innerHTML = header + rows + colorHtml;
		state( root ).lastResult = resultEl.innerHTML;
	}

	// ===== Copy / Print / Reset =====
	function copyResult( root ) {
		H.copyToClipboard( root, t );
	}

	function printResult( root ) {
		H.printContent( root, t,
			'.fvi-results-grid{display:flex;flex-direction:column;gap:8px;margin-top:12px}' +
			'.fvi-result-row{display:flex;justify-content:space-between;align-items:center;padding:10px 12px;background:#f6f4e4;border-radius:6px;border-left:4px solid #3d441e;font-size:12px}' +
			'.fvi-result-row--sage{border-left-color:#6F7C4B}' +
			'.fvi-result-row--muted{border-left-color:#dec0b4}' +
			'.fvi-result-row--accent{border-left-color:#B08947}' +
			'.fvi-result-label{color:#3d441e;opacity:0.8}' +
			'.fvi-result-value{font-weight:700;color:#3d441e}' +
			'.fvi-result-row--accent .fvi-result-value{color:#B08947}'
		);
	}

	function resetTool( root ) {
		var fields = [ 'wBottom', 'hLeft' ];
		for ( var i = 0; i < fields.length; i++ ) {
			var el = root.querySelector( '[data-fvi="' + fields[ i ] + '"]' );
			if ( el ) { el.value = ''; }
		}
		root.querySelector( '[data-fvi="result"]' ).innerHTML = PLACEHOLDER;
		state( root ).lastResult = null;
	}

	// ===== Initialization =====
	function init( root ) {
		if ( ! root || root.dataset.fviReady === '1' ) { return; }
		root.dataset.fviReady = '1';

		root.addEventListener( 'click', function ( e ) {
			var act = e.target.closest( '[data-fvi-action]' );
			if ( act && root.contains( act ) ) {
				e.preventDefault();
				var a = act.getAttribute( 'data-fvi-action' );
				if ( a === 'calc' )  { calculate( root ); }
				if ( a === 'reset' ) { resetTool( root ); }
				if ( a === 'print' ) { printResult( root ); }
				if ( a === 'copy' )  { copyResult( root ); }
			}
		}, true );
	}

	function initAll() {
		var roots = document.querySelectorAll( '.fvi-inmeettool[data-fvi-tool="schuifwand"]' );
		for ( var i = 0; i < roots.length; i++ ) { init( roots[ i ] ); }
	}

	H.ready( initAll );
	H.debounceObserver( initAll );
} )();
